export const EVENTS = {
    CHANGE: 'change',
};

export const ATTRIBUTES = {
    IMG_SRC: 'img-src',
};
